var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { reduxBind } from 'badphraim/ui/LitReduxMixinBase';
import { isErrorHTTP } from 'boost-api/APIRestClient';
import { MembersignupAPI } from 'boost-api/boost/signup/membersignup/MembersignupAPI';
import { OverlayWindow } from 'common-uicomponents/components/OverlayWindow';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { BoostPortalNavigationSteps } from '../../enums/BoostPortalNavigationSteps';
import { Callback } from '../../enums/Callback';
import { BoostPortalStore } from '../../redux/BoostPortalStore';
import { litReduxBoostPortalMixin } from '../../redux/LitReduxBoostPortalMixin';
import { BoostLoading } from './BoostLoading';
import { EitherOrSpacer } from 'cerumx-shared/EitherOrSpacer';
import { BoostPortalPaymentStatusHelper, PaymentStatus } from '../../helpers/BoostPortalPaymentStatusHelper';
import { TrackingFactorySingleton } from '../../tracking/TrackingFactorySingleton';
import { TrackingEvent } from '../../tracking/TrackingEvent';
import { BoostPortalTranslateMixin } from '../../translation/TranslateBoostPortalMixin';
import { BoostInvoiceController } from '../../controllers/BoostInvoiceController';
import { until } from 'lit/directives/until.js';
import { SnackBar } from 'common-uicomponents/components/SnackBar';
let BoostPortalPaymentOptions = class BoostPortalPaymentOptions extends BoostPortalTranslateMixin(litReduxBoostPortalMixin(LitElement)) {
    constructor() {
        super(...arguments);
        this.shortTerm = false;
        this.noDirectDebit = false;
        this.departments = [];
        this.isLoading = false;
        this.boostInvoiceController = new BoostInvoiceController(this);
    }
    static get is() {
        return 'boost-portal-payment-options';
    }
    static get styles() {
        return css `
            .payment-text-container {
                padding: 10px;
                text-align: start;
                display: flex;
                flex-direction: column;
                font-size: 18px;
            }

            .payment-container {
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .vipps-payment-container {
                padding: 15px;
                background-color: rgb(71, 124, 161) !important;
                margin-top: 40px;
                width: 50%;
                border-radius: 10px;
                justify-content: center;
                display: flex;
                margin-top: 20px;
            }

            .mail-payment-container {
                padding: 15px;
                background-color: rgb(72, 186, 151);
                width: 34%;
                border-radius: 8px;
                color: rgb(255, 255, 255);
                display: flex;
                justify-content: center;
                border-radius: 8px;
            }

            .mail-payment-container:hover,
            .selected-payment {
                background-color: #139b69 !important;
                color: #fff;
                cursor: pointer;
            }

            .vipps-payment-container:hover {
                background-color: rgb(62, 120, 172) !important;
                color: #fff;
                cursor: pointer;
            }

            either-or-spacer {
                width: 100%;
                --text-2xs: 14px;
                margin-top: 3rem;
                margin-bottom: 0.5rem;
            }

            .payment-buttons-container {
                display: flex;
                flex-direction: row;
                width: 100%;
                justify-content: space-between;
                gap: 10px;
                margin-bottom: 20px;
            }

            .payment-button {
                width: calc(50% - 5px);
                justify-content: center;
                align-items: center;
                display: flex;
                flex-direction: column;
                height: 10rem;
                border: 1px solid #dbdbdb;
                border-radius: 16px;
                box-shadow: rgba(0, 0, 0, 0.04) 0px 3px 5px;
                background-color: #fff;
                cursor: pointer;
            }

            .payment-button:hover {
                background-color: rgb(221, 221, 221);
                border: 1px solid rgb(184, 184, 184);
            }

            .pay-later-button:hover {
                background-color: rgb(221, 221, 221);
                border: 1px solid rgb(184, 184, 184);
            }

            .pay-later-button {
                width: 97%;
                padding: 10px 10px 10px 15px;
                display: flex;
                flex-direction: row;
                height: 2.4rem;
                border: 1px solid rgb(219, 219, 219);
                border-radius: 16px;
                gap: 10px;
                align-items: center;
                background-color: #fff;
                gap: 6px;
                cursor: pointer;
            }

            .logo {
                width: 3rem;
                height: 3rem;
            }

            .text-container {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

            .invoice-container {
                border: 1px solid #8798b0;
                border-radius: 8px;
                padding: 10px 20px 10px 20px;
                margin-top: 2rem;
                background-color: #fff;
            }

            p {
                color: #093845;
            }

            .icon-container {
                background-color: #e6f1fb;
                width: 3rem;
                height: 3rem;
                border-radius: 8px;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .items-container {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 10px;
            }

            .sub-header {
                font-size: 24px;
                font-weight: 500;
            }

            @media only screen and (max-width: 600px) {
                .vipps-payment-container,
                .mail-payment-container {
                    width: 70%;
                }

                either-or-spacer {
                    margin-top: 1.5rem;
                }

                .payment-text-container {
                    padding: 20px;
                    line-height: 25px;
                }
                .invoice-container {
                    width: 100%;
                    align-self: center;
                }
                .payment-buttons-container {
                    flex-direction: column;
                }
                .payment-button {
                    width: 100%;
                }
            }
        `;
    }
    /** @override */ render() {
        return html `${this.isLoading
            ? html ` <div style="padding-top:60px; ">
                  <boost-loading title="Venter på status"></boost-loading>
              </div>`
            : this._renderPaymentStatusOptions()}`;
    }
    _renderPaymentStatusOptions() {
        if (this.callback === Callback.NETS) {
            return this._renderPaymentOptions();
        }
        if (this.callback === Callback.VIPPS) {
            if (this.paymentStatus === PaymentStatus.ABORTED ||
                this.paymentStatus === PaymentStatus.TERMINATED ||
                this.paymentStatus === PaymentStatus.EXPIRED) {
                return this._renderVippsStatusFailed();
            }
        }
    }
    _loadPaymentStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.invoice) {
                return;
            }
            this.isLoading = true;
            this.paymentStatus = yield BoostPortalPaymentStatusHelper.getPaymentStatus(this.invoice.invoice.id);
            if (this.paymentStatus === PaymentStatus.PAYMENTSUCCESS) {
                this._changeStepToSuccess();
            }
            this.isLoading = false;
        });
    }
    _renderPaymentOptions() {
        return html `<div class="container">
            <div class="payment-text-container">${until(this._renderPaymentOptionText())}</div>
            ${until(this._renderPaymentButtons())}
        </div>`;
    }
    _renderPaymentOptionText() {
        return __awaiter(this, void 0, void 0, function* () {
            const isInvoicePaid = yield this.boostInvoiceController.isInvoicePaid();
            if (isInvoicePaid) {
                return html ` ${this.boostTranslateOutputHtml('complete-payment-info')}`;
            }
            if (!this.shortTerm && !this.noDirectDebit) {
                return this._renderMonthlyMembershipPaymentText();
            }
            else if (this.shortTerm) {
                return this._renderShortTermMembershipPaymentText();
            }
            return this._renderPayInvoiceText();
        });
    }
    _renderPayInvoiceText() {
        var _a, _b, _c;
        const totalPrice = this._getSummarizedInvoicePrice();
        return html ` <p style="font-size: 26px; font-weight: 500;">
                ${this.boostTranslateOutputHtml('pay-invoice')}
            </p>
            <div style="background-color: #e6f1fb; border-radius: 8px; ">
                <p style="font-size: 18px; margin:0; padding:10px;">
                    ${this.boostTranslateOutputHtml('due-date', {
            dueDate: (_c = (_b = (_a = this.invoice) === null || _a === void 0 ? void 0 : _a.invoice.forfall) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '',
        })}
                </p>
            </div>
            <div class="invoice-container">
                <div class="items-container">
                    <div class="icon-container">
                        <img style="width:1.5rem" src="/images/icons/invoice-blue.svg" />
                    </div>
                    <p class="sub-header">${this.boostTranslateOutputHtml('invoice')}</p>
                </div>
                ${this._getInvoiceLines()}
                <hr style="  border: none; height: 2px; background-color: #eee;" />
                <div style="display:flex; flex-direction:row; justify-content: space-between;">
                    <p style="font-size: 20px; font-weight: 500;">
                        ${this.boostTranslateOutputHtml('total-invoice-amount')}
                    </p>
                    <p style="font-size: 20px; font-weight: 500;">
                        ${totalPrice.toString().replace('.', ',')},-
                    </p>
                </div>
            </div>`;
    }
    _getSummarizedInvoicePrice() {
        if (!this.invoice) {
            return 0;
        }
        return this.invoice.invoice.linjer.reduce((lhs, rhs) => { var _a; return lhs + Number((_a = rhs.pris) !== null && _a !== void 0 ? _a : 0); }, 0);
    }
    _renderMonthlyMembershipPaymentText() {
        const totalPrice = this._getSummarizedInvoicePrice();
        return html ` <p style="font-size: 26px; font-weight: 500;">
                ${this.boostTranslateOutputHtml('agreement-activated')}
            </p>
            <p style="font-size: 18px; margin:0">
                ${this.boostTranslateOutputHtml('complete-registration-membership')}
            </p>
            <div class="invoice-container">
                <div class="items-container">
                    <div class="icon-container">
                        <img style="width:1.5rem" src="/images/icons/invoice-blue.svg" />
                    </div>
                    <p class="sub-header">${this.boostTranslateOutputHtml('invoice')}</p>
                </div>
                ${this._getInvoiceLines()}
                <hr style="border: none; height: 2px; background-color: #eee;" />
                <div style="display:flex; flex-direction:row; justify-content: space-between;">
                    <p class="sub-header">${this.boostTranslateOutputHtml('total-invoice-amount')}</p>
                    <p style="font-size: 20px; font-weight: 500;">
                        ${totalPrice.toString().replace('.', ',')},-
                    </p>
                </div>
            </div>`;
    }
    _renderShortTermMembershipPaymentText() {
        const totalPrice = this._getSummarizedInvoicePrice();
        return html `
            <p style="font-size: 26px; font-weight: 500;">
                ${this.boostTranslateOutputHtml('complete-order')}
            </p>
            <p style="font-size: 18px; margin:0">
                ${this.boostTranslateOutputHtml('complete-registration-shortterm-membership')}
            </p>
            <div class="invoice-container">
                <div class="items-container">
                    <div class="icon-container">
                        <img style="width:1.5rem" src="/images/icons/invoice-blue.svg" />
                    </div>
                    <p class="sub-header" style="">
                        ${this.boostTranslateOutputHtml('short-term-membership')}
                    </p>
                </div>

                ${this._getInvoiceLines()}
                <hr style="  border: none; height: 2px; background-color: #eee;" />
                <div style="display:flex; flex-direction:row; justify-content: space-between;">
                    <p style="font-size: 20px; font-weight: 500;">
                        ${this.boostTranslateOutputHtml('total-invoice-amount')}
                    </p>
                    <p style="font-size: 20px; font-weight: 500;">
                        ${totalPrice.toString().replace('.', ',')},-
                    </p>
                </div>
            </div>
        `;
    }
    _getInvoiceLines() {
        var _a;
        const invoiceLines = (_a = this.invoice) === null || _a === void 0 ? void 0 : _a.invoice.linjer;
        return invoiceLines === null || invoiceLines === void 0 ? void 0 : invoiceLines.map((invoiceLine) => {
            var _a, _b, _c, _d;
            return html `
                <div style="display:flex; flex-direction:row; justify-content: space-between;">
                    <p style="font-size: 18px; margin:0">${(_b = (_a = invoiceLine.tekst) === null || _a === void 0 ? void 0 : _a.replace('-', ' - ')) !== null && _b !== void 0 ? _b : ''}</p>
                    <p style="font-size: 18px; font-weight:400; margin:0;">
                        ${(_d = (_c = invoiceLine.pris) === null || _c === void 0 ? void 0 : _c.toString().replace('.', ',')) !== null && _d !== void 0 ? _d : ''},-
                    </p>
                </div>
            `;
        });
    }
    _renderVippsStatusFailed() {
        return html ` <div>
            <div style="padding-top:20px">
                <div class="payment-text-container">${this._renderPaymentFailed()}</div>
                ${until(this._renderPaymentButtons())}
            </div>
        </div>`;
    }
    _renderPaymentFailed() {
        var _a, _b;
        if (!this.shortTerm && !this.noDirectDebit) {
            return html `<span style="font-size:30px; padding-bottom:6px;"> OBS! </span>
                <span>
                    ${this.boostTranslateOutputHtml('payment-failed', {
                invoice: (_b = (_a = this.invoice) === null || _a === void 0 ? void 0 : _a.first_invoice_date.slice(3, 10).toString()) !== null && _b !== void 0 ? _b : '',
            })}
                </span>`;
        }
        else if (this.shortTerm && !this.noDirectDebit) {
            return html `<span style="font-size:30px; padding-bottom:6px;"> OBS! </span>
                <span>
                    ${this.boostTranslate('payment-failed-try-again')} <br />
                    <br />
                </span> `;
        }
        return html `<span style="font-size:30px; padding-bottom:6px;"> OBS! </span>
            <span> ${this.boostTranslateOutputHtml('payment-failed-try-again')}</span>`;
    }
    _renderPaymentButtons() {
        return __awaiter(this, void 0, void 0, function* () {
            const isInvoicePaid = yield this.boostInvoiceController.isInvoicePaid();
            if (isInvoicePaid) {
                return html `<div class="payment-container">
                <div class="mail-payment-container" @click="${() => this._changeStepToSuccess()}">
                    <span style="align-self:center; font-size:20px;"
                        >${this.boostTranslateOutputHtml('succeed-button')}</span
                    >
                </div>
            </div>`;
            }
            return html `
            <p style="text-transform: uppercase; font-weight: 500; color: dimgray; font-size:18px;">
                ${this.boostTranslateOutputHtml('choose-payment-method')}
            </p>
            <div class="payment-buttons-container">
                <div class="payment-button" @click="${() => this._openPayment(false)}">
                    <img class="logo" src="/images/logos/main-logo.svg" />
                    <div class="text-container">
                        <p style="font-weight: 500;font-size:20px; margin:0px">Vipps</p>
                        <span style="color: dimgray;">${this.boostTranslateOutputHtml('vipps-payment')}</span>
                    </div>
                </div>
                <div class="payment-button" @click="${() => this._openPayment(true)}">
                    <img class="logo" src="/images/icons/credit-card.svg" />
                    <div class="text-container">
                        <p style="font-weight: 500;font-size:20px; margin:0px">
                            ${this.boostTranslateOutputHtml('card-payment')}
                        </p>
                        <span style="color: dimgray;">Visa / Mastercard</span>
                    </div>
                </div>
            </div>
            ${!this.shortTerm
                ? html `<either-or-spacer text="${this.boostTranslate('either-or')}"></either-or-spacer>

                      <div class="pay-later-button" @click="${() => this._changeStepToSuccess()}">
                          <img style="width:1rem;" src="/images/icons/bank.svg" />
                          <span style="color: dimgray;">${this.boostTranslateOutputHtml('pay-later')}</span>
                      </div>`
                : nothing}
        `;
        });
    }
    _changeStepToSuccess() {
        this.redirectUrl = this._getRedirectUrl();
        TrackingFactorySingleton.getTracker().completedEvent(TrackingEvent.MemberSignupCompleted);
        if (this.redirectUrl) {
            window.location.href = this.redirectUrl;
        }
        this.dispatchEvent(new CustomEvent('currentStep-changed', {
            detail: {
                currentStep: BoostPortalNavigationSteps.SUCCESS,
            },
            bubbles: true,
            composed: true,
        }));
    }
    _renderMembership() {
        var _a, _b;
        return html `
            <div>${(_a = this.selectedMembership) === null || _a === void 0 ? void 0 : _a.title} ${(_b = this.selectedMembership) === null || _b === void 0 ? void 0 : _b.cost_included_vat},-</div>
        `;
    }
    _getFallbackUrl() {
        var _a;
        if (this.redirectUrl) {
            return this.redirectUrl;
        }
        const url = `${window.location.origin}/${this.centerShort}/betaling`;
        if (!url) {
            console.error('Mangler url');
            return '';
        }
        return `${url}?invoiceId=${(_a = this.invoice) === null || _a === void 0 ? void 0 : _a.invoice.id}&shortTerm=${this.shortTerm}`;
    }
    _openPayment(isCard) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.invoice || this.isLoading) {
                console.error('Mangler invoiceID');
                return;
            }
            this.redirectUrl = this._getRedirectUrl();
            const fallback = this._getFallbackUrl();
            this.isLoading = true;
            let paymentType = null;
            if (isCard !== undefined) {
                paymentType = isCard ? 'card' : 'standard';
            }
            const vippsUrlRequest = yield MembersignupAPI.postV2BoostsignupInitiatepayment({
                paymentType,
                invoice_id: this.invoice.invoice.id,
                fallback,
            });
            this.isLoading = false;
            this.paymentStatus = PaymentStatus.CREATED;
            if (isErrorHTTP(vippsUrlRequest)) {
                console.error('Vipps payment initiation failed', vippsUrlRequest);
                return;
            }
            const { payment_url: paymentUrl } = vippsUrlRequest;
            if (!paymentUrl) {
                SnackBar.pushError('Mangler betalingslenke');
                return;
            }
            window.location.href = paymentUrl;
        });
    }
    _getSelectedDepartment() {
        var _a;
        const departmentId = (_a = this.invoice) === null || _a === void 0 ? void 0 : _a.invoice.avdeling;
        if (departmentId) {
            return this.departments.find((department) => department.id === departmentId);
        }
    }
    _getRedirectUrl() {
        const selectedDepartment = this._getSelectedDepartment();
        if (selectedDepartment === null || selectedDepartment === void 0 ? void 0 : selectedDepartment.portal_redirect_url) {
            return selectedDepartment.portal_redirect_url;
        }
        return '';
    }
    _invoiceObserver() {
        if (!this.invoice) {
            return;
        }
        this.boostInvoiceController.setInvoice(this.invoice);
        this._loadPaymentStatus();
    }
    /** @override */ updated(changedProperties) {
        changedProperties.forEach((_oldValue, propertyName) => {
            switch (propertyName) {
                case 'invoice':
                    this._invoiceObserver();
            }
        });
        super.updated(changedProperties);
    }
};
BoostPortalPaymentOptions._deps = [OverlayWindow, BoostLoading, EitherOrSpacer];
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], BoostPortalPaymentOptions.prototype, "selectedMembership", void 0);
__decorate([
    property({ type: Object }),
    __metadata("design:type", Object)
], BoostPortalPaymentOptions.prototype, "invoice", void 0);
__decorate([
    state(),
    __metadata("design:type", String)
], BoostPortalPaymentOptions.prototype, "paymentStatus", void 0);
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], BoostPortalPaymentOptions.prototype, "callback", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Boolean)
], BoostPortalPaymentOptions.prototype, "shortTerm", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Boolean)
], BoostPortalPaymentOptions.prototype, "noDirectDebit", void 0);
__decorate([
    state(),
    __metadata("design:type", String)
], BoostPortalPaymentOptions.prototype, "redirectUrl", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('departments')),
    state(),
    __metadata("design:type", Array)
], BoostPortalPaymentOptions.prototype, "departments", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], BoostPortalPaymentOptions.prototype, "isLoading", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('centerShort')),
    state(),
    __metadata("design:type", String)
], BoostPortalPaymentOptions.prototype, "centerShort", void 0);
BoostPortalPaymentOptions = __decorate([
    customElement(BoostPortalPaymentOptions.is)
], BoostPortalPaymentOptions);
export { BoostPortalPaymentOptions };
